export default {
  STORAGE_KEY_TOKEN: 'Aden0x0000',
  STORAGE_KEY_USERINFO: 'Aden0x0001',
  STORAGE_KEY_ACCESS: 'Aden0x0002',
  STORAGE_KEY_ROUTERS: 'Aden0x0004'
};
